import {useState, useEffect, useContext} from 'react'

import BuyingStep1 from '../../common/components/BuyingStep1'
import UserContext from '../../common/helpers/userContext'
import MultiStepForm from '../../common/components/MultiStepForm'
import newReceiver from '../../common/helpers/newReceiver'
import { createService } from '../../common/services/serviceFactory'

function BuyingCombos() {
  
  const {clientData, selectedComboToBuy} = useContext(UserContext)
  
  const initialFormState = {
    //DEL CLIENTE
    clientName: "",
    email: "",
    combo: selectedComboToBuy.name,
    price: selectedComboToBuy.price,
    creditCard: "",
    //DEL DESTINATARIO
    receiverName: "",
    carnet: "",
    province: "",
    township: "",
    principalStreet:"",
    middleStreets:"",
    buildingNumber:"",
    distribution:"",
    phone: "",
     //stripe Info
    stripeProductName: "",
    stripeProductPrice: 0,
  }
  const [buyingCombos, setBuyingCombos] = useState(initialFormState)

  const [selectedReceiver, setSelectedReceiver] = useState("")
  const [registeredReceivers, setRegisteredReceivers] = useState([])

  useEffect(()=>{
    const accessToken = localStorage.getItem("accessToken")

    setBuyingCombos( (prevBuyingCombos) => {
      return {
        ...prevBuyingCombos,
        email: clientData.email,
        clientName: clientData.clientName,
      }
    })

    if( accessToken ) {
      const receiverService = createService('receivers');
      receiverService.getAll(accessToken)
        .then((receiversData) => {
          console.log(receiversData)
          setBuyingCombos( (prevBuyingCombos) => {
            return {
              ...prevBuyingCombos,
              email: clientData.email,
              clientName: clientData.clientName,
            }
          })
          setRegisteredReceivers([newReceiver, ...receiversData])
        })
        .catch(e => console.log("Error fetching receivers:", e))
    }
  },[clientData.clientName, clientData.email, setBuyingCombos])

  return (
    <>
      <div className='shopContainer flex flex-column justify-center align-center'>
        <MultiStepForm
          route={"/buys/sendCombo"}
          DTO={buyingCombos}
          setDTO={setBuyingCombos}
        >
            <BuyingStep1
             DTO={buyingCombos}
             setDTO={setBuyingCombos}
             registeredReceivers={registeredReceivers}
              selectedReceiver={selectedReceiver}
              setSelectedReceiver={setSelectedReceiver}/>
        </MultiStepForm>
      </div>
    </>
  )
}

export default BuyingCombos